/**
 * Trigger a browser download of an in-memory text file (issue #299).
 *
 * Kept as a one-liner util so the mission export UI stays declarative and the
 * DOM side-effect can be stubbed in tests (URL.createObjectURL is not
 * implemented by jsdom).
 */
export const downloadTextFile = (
  filename: string,
  text: string,
  mimeType = 'text/plain'
): void => {
  const blob = new Blob([text], { type: mimeType });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
};
